import { components } from "@certn/api/generated-schemas/applicant-portal";
import { StepType } from "@certn/cascadia-react/components/stepper/ActivityStepper";
import { formatDate } from "@certn/utils";
import { TFunction } from "i18next";

type CompleteCaseList = components["schemas"]["CompleteCaseList"];

export function buildSubmittedTimelineSteps(
  caseInstance: CompleteCaseList,
  t: TFunction
): StepType[] {
  const progressSteps: StepType[] = [];
  const lastIndex = caseInstance.logs?.length && caseInstance.logs.length - 1;

  caseInstance.logs?.forEach(({ additional_data, timestamp }, index) => {
    if (additional_data?.event === "APPLICANT_SUBMITTED") {
      progressSteps.push({
        title: t("Submitted"),
        description: t("You submitted the application to Certn on {{date}}", {
          date: formatDate(timestamp, "PPP"),
        }),
        status: "COMPLETE",
      });
      progressSteps.push({
        title: t("Processing"),
        description:
          lastIndex === index
            ? t("Certn is currently processing the report")
            : t("Certn sent the report to {{name}}", {
                name: caseInstance.customer_name,
              }),
        status: lastIndex === index ? "INCOMPLETE" : "COMPLETE",
      });
    }

    if (additional_data?.event === "CHECK_DISPUTED") {
      progressSteps.push({
        title: t("In dispute"),
        description: t("Completed {{date}}", {
          date: formatDate(timestamp, "PPP"),
        }),
        status: "COMPLETE",
      });
    }
  });

  progressSteps.push({
    title: t("Complete"),
    description: "",
    status: "INCOMPLETE",
  });

  return progressSteps;
}

export function buildSubmittedScreenTimelineSteps(t: TFunction): StepType[] {
  return [
    {
      title: t("Submitted"),
      description: t("You submitted the application to Certn"),
      status: "COMPLETE",
    },
    {
      title: t("Processing"),
      description: t("Certn is currently processing the report"),
      status: "INCOMPLETE",
    },
    {
      title: t("Complete"),
      description: "",
      status: "INCOMPLETE",
    },
  ];
}
